import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function TermsPage() {
  return <div className="min-h-screen bg-background text-textMain" data-id="element-7166">
      <header className="h-16 border-b border-border flex items-center px-6 bg-surface/50 backdrop-blur sticky top-0 z-50" data-id="element-7167">
        <Link to="/" className="flex items-center gap-2" data-id="element-7168">
          <span className="text-xl font-bold" data-id="element-7169">Booker</span>
          <div className="w-1.5 h-1.5 rounded-full bg-primary" data-id="element-7170"></div>
        </Link>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="max-w-3xl mx-auto px-6 py-16" data-id="element-7171">
        <h1 className="text-4xl font-bold mb-4" data-id="element-7172">Terms of Service</h1>
        <p className="text-textMuted mb-12" data-id="element-7173">Last updated: April 6, 2026</p>

        <div className="prose prose-invert max-w-none space-y-8 text-textMuted" data-id="element-7174">
          <section data-id="element-7175">
            <h2 className="text-2xl font-bold text-textMain mb-4" data-id="element-7176">
              1. Acceptance of Terms
            </h2>
            <p data-id="element-7177">
              By accessing or using the Booker platform, you agree to be bound
              by these Terms of Service. If you disagree with any part of the
              terms, you may not access the service.
            </p>
          </section>

          <section data-id="element-7178">
            <h2 className="text-2xl font-bold text-textMain mb-4" data-id="element-7179">
              2. Description of Service
            </h2>
            <p data-id="element-7180">
              Booker provides a booking operating system for live performance,
              including tools for discovery, outreach, negotiation, contract
              generation, and payment processing. We are a software provider,
              not a booking agency, promoter, or talent buyer.
            </p>
          </section>

          <section data-id="element-7181">
            <h2 className="text-2xl font-bold text-textMain mb-4" data-id="element-7182">
              3. User Accounts
            </h2>
            <p data-id="element-7183">
              You must provide accurate and complete information when creating
              an account. You are responsible for safeguarding your password and
              for all activities that occur under your account.
            </p>
          </section>

          <section data-id="element-7184">
            <h2 className="text-2xl font-bold text-textMain mb-4" data-id="element-7185">
              4. Payments and Fees
            </h2>
            <p data-id="element-7186">
              Subscription fees are billed in advance on a recurring basis.
              Payments processed through the platform (such as deposits or
              settlements) are subject to standard payment processing fees via
              our third-party payment providers (e.g., Stripe).
            </p>
          </section>

          <section data-id="element-7187">
            <h2 className="text-2xl font-bold text-textMain mb-4" data-id="element-7188">
              5. Content and Data
            </h2>
            <p data-id="element-7189">
              You retain all rights to the data, contacts, and content you
              upload to Booker. By using the service, you grant us a license to
              host, store, and process this data solely for the purpose of
              providing the service to you.
            </p>
          </section>
        </div>
      </motion.div>
    </div>;
}